/**
 * React Query hooks for the Infrastructure screen.
 *
 * Polling cadences are intentionally tab-specific:
 *   - Health: every 10s. Operator looks at this when something feels
 *     wrong; we want to see the impact of remediations in seconds, not
 *     minutes.
 *   - Components: every 60s. Manifests change rarely; per-component
 *     live session counts are interesting but don't move every second.
 *   - Timeline: every 60s. Hour buckets, so faster polling adds no
 *     visible signal.
 */
import { useQuery } from '@tanstack/react-query';
import {
  fetchInfraComponents,
  fetchInfraHealth,
  fetchSessionsTimeline
} from '@/api/adminInfra';

export function useInfraHealth() {
  return useQuery({
    queryKey: ['adminInfraHealth'],
    queryFn: fetchInfraHealth,
    refetchInterval: 10_000
  });
}

export function useInfraComponents() {
  return useQuery({
    queryKey: ['adminInfraComponents'],
    queryFn: fetchInfraComponents,
    refetchInterval: 60_000
  });
}

export function useSessionsTimeline() {
  return useQuery({
    queryKey: ['adminSessionsTimeline'],
    queryFn: fetchSessionsTimeline,
    refetchInterval: 60_000
  });
}
